import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatDate(date: string, locale: string) {
    if (!date) return '';
    return new Date(date).toLocaleDateString(
        locale === 'nl' ? 'nl-NL' : 'en-US',
        {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        },
    );
}

export function kebabCase(str: string) {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
        .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
}

export function countDecimals(n: number) {
    const s = n.toString();
    const idx = s.indexOf('.');
    return idx === -1 ? 0 : s.length - idx - 1;
}

export function formatNumber(n: number, decimals = 0) {
    if (isNaN(n)) return '0';

    const fixed = n.toFixed(decimals);
    const parts = fixed.split('.');

    const integerPart = parts[0]
        ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        : '0';
    const decimalPart = parts[1] ?? '';

    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
}

export function isNumeric(v: string | number) {
    if (typeof v === 'number' && Number.isFinite(v)) return true;
    if (typeof v === 'string') {
        // Trim and allow decimals with dot or comma; normalize comma to dot
        const s = v.trim().replace(',', '.');
        return s !== '' && !isNaN(Number(s));
    }
    return false;
}

export function toNumber(v: string | number): number | null {
    if (!isNumeric(v)) return null;
    return typeof v === 'number' ? v : Number(v.trim().replace(',', '.'));
}
